<div class="single-ticket__top-content">
    <div class="single-ticket-left-content">
        <div class="single-ticket-left-content__items" *ngIf="tickets.origin_stop_name">
            <span class="title">{{ 'TICKET_SUMMARY_V2_ROUTE' | translate }}</span>
            <span class="description">
                {{ tickets.origin_stop_name }} › {{ tickets.destination_stop_name }}
                <ridango-trip-message *ngIf="hasTripMessages" [messages]="tripMessages" [locale]="locale">
                </ridango-trip-message>
            </span>
        </div>
        <div class="single-ticket-left-content__items" *ngIf="!tickets.origin_stop_name">
            <span class="title">{{ 'TICKET_SUMMARY_V2_ZONE' | translate }}</span>
            <span class="description">{{ tickets.origin_zone_name }} › {{ tickets.destination_zone_name }}</span>
        </div>
        <div class="single-ticket-left-content__items">
            <span class="title">{{ 'TICKET_SUMMARY_V2_DEPARTURE' | translate }}</span>
            <span class="description"
                >{{ getTime(tickets, 'D') }} › {{ getTime(tickets, 'A') }}
                <span class="date">
                    <!-- {{tickets.starting_formatted}} -->
                    {{ tickets.starting | findDayName | translate }} {{ formatDate(tickets.starting) }}
                </span>
            </span>
        </div>
    </div>

    <div class="single-ticket-right-content">
        <div class="single-ticket-left-content__items full-width">
            <span class="title">{{ 'TICKET_SUMMARY_V2_TOTAL_PRICE' | translate }}</span>
            <span class="description">{{ tickets.total | moneyFormat }} € </span>
        </div>
    </div>
</div>

<!--It had to be added here otherwise mobile is all broken-->

<div class="single-ticket-left-content remove-padding-margin-border">
    <div class="single-ticket-left-content__items ticket-type">
        <span class="title">{{ 'TICKET_SUMMARY_V2_TICKET_TYPE' | translate }}</span>
    </div>

    <div class="single-ticket-left-content__items traveller-card">
        <span class="title">
            <!-- <span 
                    class="inline-title">traveller</span>
                <span class="dash">/</span>
                <span 
                    class="inline-title">card</span> -->
            <span class="inline-title">{{ 'TICKET_SUMMARY_V2_TRAVELLER_CARD' | translate }}</span>
        </span>
    </div>
</div>

<div class="single-ticket-right-content remove-padding-margin-border ticket-price">
    <div class="single-ticket-left-content__items">
        <span class="title">{{ 'TICKET_SUMMARY_V2_PRICE' | translate }}</span>
    </div>
</div>
